var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('page-title',{staticClass:"mb-4",attrs:{"title":_vm.$t('playlist').toString(),"sub-title":_vm.$t('playlist_sub_title').toString()}}),_c('div',{staticClass:"page-content"},[_c('AdSpacesPlaylist')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }